<template>
  <v-card color="rgba(41, 41, 47, 0.8)">
    <v-card-title> {{ $t("Addtemporaryroad") }} </v-card-title>
    <v-card-text>
      <v-form v-model="isValid">
        <v-row class="ma-0">
          <v-col cols="6">
            <v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)">
              <tbody>
                <tr>
                  <td style="width: 50%">
                    {{ $t("Roadname") }}
                  </td>
                  <td>
                    <v-text-field variant="underlined" hide-details density="compact" v-model="property.name"
                      :rules="[rules.validName, rules.maxLength(100), rules.minLength(1)]" autofocus />
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="6">
            <!-- 道路・摺り付け -->
            {{ $t("Roadparameter") }}
            <v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)">
              <tbody>
                <!-- 道路幅_左 -->
                <tr>
                  <td style="width: 50%">
                    {{ $t("Widthofroad") }} {{ $t("Left") }}
                  </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                      :min-value="0" :max-value="99.999" :decimal-length="3"
                      v-model="property.pathSettings.leftWidth" />
                  </td>
                </tr>
                <!-- 道路幅_右 -->
                <tr>
                  <td>
                    <span style="opacity: 0">{{ $t("Widthofroad") }}</span>
                    {{ $t("Right") }}
                  </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                      :min-value="0" :max-value="99.999" :decimal-length="3"
                      v-model="property.pathSettings.rightWidth" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ $t("Setsuperelevation") }}
                  </td>
                  <td>
                    <v-select variant="underlined" v-model="property.pathSettings.isSuperElevation" :items="slopeTypes"
                      item-title="label" item-value="value" hide-details density="compact" class="ma-0"
                      v-on:update:model-value="updateRoadSettings()"></v-select>
                  </td>
                </tr>
                <!-- 片勾配 -->
                <tr v-if="property.pathSettings.isSuperElevation">
                  <td>
                    <div>
                      {{ $t("Superelevation") }}
                    </div>
                  </td>
                  <td>
                    <SlopeSettingInput variant="underlined"
                      :suffix-to-display="getSuffix(roadParameterSlopeUnit.superElevation)" :is-editable="true"
                      :slope-value="property.pathSettings.leftSlope" :step="0.01" @blur="updateRoadSettings()"
                      v-model.number="property.pathSettings.leftSlope" :max-value="9999.99" :min-value="-9999.99"
                      :decimal-length="2" :un-valid-zero="roadParameterSlopeUnit.superElevation === 'percent'">
                    </SlopeSettingInput>
                  </td>
                </tr>
                <!-- 横断勾配 -->
                <tr v-else>
                  <td>
                    <div>
                      {{ $t("Crossslope") }}
                    </div>
                  </td>
                  <td>
                    <SlopeSettingInput variant="underlined"
                      :suffix-to-display="getSuffix(roadParameterSlopeUnit.crossSlope)" :is-editable="true"
                      :slope-value="property.pathSettings.leftSlope" :step="0.01" @blur="updateRoadSettings()"
                      v-model.number="property.pathSettings.leftSlope"
                      :max-value="roadParameterSlopeUnit.crossSlope === 'percent' ? 9999.99 : 999.99"
                      :min-value="roadParameterSlopeUnit.crossSlope === 'percent' ? 0 : 0.01" :decimal-length="2"
                      :un-valid-zero="roadParameterSlopeUnit.crossSlope === 'percent'"></SlopeSettingInput>
                  </td>
                </tr>
                <!-- 摺り付けピッチ -->
                <tr>
                  <td>
                    {{ $t("InterpolationPitch") }}
                  </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                      :min-value="0.001" :max-value="99.999" :decimal-length="3"
                      v-model="property.pathSettings.interpolationPitch" />
                  </td>
                </tr>
                <!-- 路面色 -->
                <tr>
                  <td>
                    {{ $t("ROAD_SURFACE_COLOR") }}
                  </td>
                  <td>
                    <v-menu>
                      <template v-slot:activator="{ props }">
                        <v-avatar :color="property.pathSettings.surfaceColor" size="20px" v-bind="props">
                        </v-avatar>
                      </template>
                      <v-color-picker class="ma-0" hide-canvas hide-inputs hide-sliders show-swatches mode="hexa"
                        v-model="property.pathSettings.surfaceColor"></v-color-picker>
                    </v-menu>
                  </td>
                </tr>
                <!-- 縦断勾配指定 -->
                <tr>
                  <td>
                    {{ $t("ENABLE_VERTICAL_SLOPE_VALUE") }}
                  </td>
                  <td>
                    <v-checkbox color="primary" hide-details density="compact" class="ma-0"
                      v-model="isSlopeValueEnabled"></v-checkbox>
                  </td>
                </tr>
                <!-- 縦断勾配 -->
                <tr v-show="isSlopeValueEnabled">
                  <td>
                    {{ $t("Longitudinal_Slope_Value") }}
                  </td>
                  <td>
                    <SlopeSettingInput variant="underlined"
                      :suffix-to-display="getSuffix(roadParameterSlopeUnit.longitudinalSlope)" :is-editable="true"
                      :slope-value="slopeValue" :step="longitudinalSlope.step" v-model.number="slopeValue"
                      :max-value="longitudinalSlope.maxValue" :min-value="longitudinalSlope.minValue"
                      :decimal-length="longitudinalSlope.decimalLength" :un-valid-zero=true>
                    </SlopeSettingInput>
                  </td>
                </tr>
                <!-- 参照基準点 -->
                <tr v-show="isSlopeValueEnabled">
                  <td>
                    {{ $t("Slope_Reference_Point") }}
                  </td>
                  <td>
                    <v-select variant="underlined" v-model="referencePointIndex" :items="longitudinalReferencePoints"
                      item-title="label" item-value="value" hide-details density="compact" class="ma-0"></v-select>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
          <v-col cols="6">
            <!-- 線形設定値 -->
            {{ $t("LineWorkparamater") }}
            <v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)">
              <tbody>
                <!-- 断面幅_左 -->
                <tr>
                  <td style="width: 50%">
                    {{ $t("WidthofLineWork") }} {{ $t("Left") }}
                  </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                      :min-value="1" :max-value="999.999" :decimal-length="3"
                      v-model="property.crossSectionSetting.leftWidth" />
                  </td>
                </tr>
                <!-- 断面幅_右 -->
                <tr>
                  <td>
                    <span style="opacity: 0">{{ $t("WidthofLineWork") }}</span>
                    {{ $t("Right") }}
                  </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                      :min-value="1" :max-value="999.999" :decimal-length="3"
                      v-model="property.crossSectionSetting.rightWidth" />
                  </td>
                </tr>
                <!-- 測点間隔 -->
                <tr>
                  <td>
                    {{ $t("STATION_INTERVAL") }}
                  </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                      :min-value="1" :max-value="999.999" :decimal-length="3"
                      v-model="property.crossSectionSetting.interpolationPitch" />
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col>
            <!-- 切土設定 -->
            <v-row class="ma-0">
              <v-col class="py-0">
                {{ $t("Cutsetting") }}
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col>
                <v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)">
                  <tbody>
                    <!-- 法面高さ -->
                    <tr>
                      <td style="width: 50%">
                        {{ $t("Slopeheight") }}
                      </td>
                      <td>
                        <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                          :min-value="0.001" :max-value="99.999" :decimal-length="3" :disabled="cutSlopeCondition"
                          @blur="updateRoadSettings()" v-model="property.cutSettings.roadHeight" />
                      </td>
                    </tr>
                    <!-- 法面勾配 -->
                    <tr>
                      <td>
                        {{ $t("Slopegradient") }}
                      </td>
                      <td>

                        <SlopeSettingInput variant="underlined"
                          :suffix-to-display="getSuffix(cutSettingSlopeUnit.slopeGradient)"
                          :is-editable="!property.cutSettings.isLeftRightDifferent"
                          :slope-value="property.cutSettings.moundSlope" :step="0.01" @blur="updateRoadSettings()"
                          v-model.number="property.cutSettings.moundSlope"
                          :max-value="cutSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                          :min-value="0.01" :decimal-length="2" :un-valid-zero="false"></SlopeSettingInput>


                      </td>
                    </tr>
                    <!-- 小段幅 -->
                    <tr>
                      <td>
                        {{ $t("Bermwidth") }}
                      </td>
                      <td>

                        <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                          :min-value="0.001" :max-value="99.999" :decimal-length="3" :disabled="cutSlopeCondition"
                          @blur="updateRoadSettings()" v-model="property.cutSettings.shelfWidth" />
                      </td>
                    </tr>
                    <!-- 小段勾配 -->
                    <tr>
                      <td>
                        {{ $t("Bermgradient") }}
                      </td>
                      <td>


                        <SlopeSettingInput variant="underlined"
                          :suffix-to-display="getSuffix(cutSettingSlopeUnit.bermGradient)"
                          :is-editable="!cutSlopeCondition" :slope-value="property.cutSettings.shelfSlope" :step="0.01"
                          @blur="updateRoadSettings()" v-model.number="property.cutSettings.shelfSlope"
                          :max-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                          :min-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01" :decimal-length="2"
                          :un-valid-zero="cutSettingSlopeUnit.bermGradient === 'percent'"></SlopeSettingInput>

                      </td>
                    </tr>
                    <!-- 左右設定 -->
                    <tr>
                      <td>
                        {{ $t("LeftRightSettings") }}
                      </td>
                      <td>
                        <v-checkbox color="primary" hide-details density="compact" class="ma-0"
                          @change="updateRoadSettings()"
                          v-model="property.cutSettings.isLeftRightDifferent"></v-checkbox>
                      </td>
                    </tr>
                    <!-- 小段あり -->
                    <tr>
                      <td>
                        {{ $t("Thereisberm") }}
                      </td>
                      <td>
                        <v-checkbox color="primary" hide-details density="compact" class="ma-0"
                          v-model="property.cutSettings.generateShelf"></v-checkbox>
                      </td>
                    </tr>
                    <!-- 法面色 -->
                    <tr>
                      <td>
                        {{ $t("SLOPE_COLOR") }}
                      </td>
                      <td>
                        <v-menu>
                          <template v-slot:activator="{ props }">
                            <v-avatar :color="property.cutSettings.color" size="20px" v-bind="props">
                            </v-avatar>
                          </template>
                          <v-color-picker class="ma-0" hide-canvas hide-inputs hide-sliders show-swatches mode="hexa"
                            v-model="property.cutSettings.color"></v-color-picker>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
                <!-- 左右設定 -->
                <v-expansion-panels>
                  <v-expansion-panel style="background-color: rgba(41, 41, 47, 0)">
                    <v-expansion-panel-title class="px-4 py-0">
                      {{ $t("Leftrightsetting") }}
                    </v-expansion-panel-title>
                    <v-expansion-panel-text class="pt-2">
                      <v-row class="ma-0">
                        <!-- 左切土設定 -->
                        <v-col class="pa-0">
                          {{ $t("Leftcutsetting") }}
                          <v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)" class="pa-0">
                            <tbody>
                              <!-- 法面高さ -->
                              <tr>
                                <td style="width: 45%">
                                  {{ $t("Slopeheight") }}
                                </td>
                                <td>
                                  <DistanceSettingInput variant="underlined" hide-details density="compact"
                                    :step="0.001" :min-value="0.001" :max-value="99.999" :decimal-length="3"
                                    :disabled="cutLeftRightCondition" v-model="property.cutSettings.leftSlopeHeight" />
                                </td>
                              </tr>
                              <!-- 法面勾配 -->
                              <tr>
                                <td>
                                  {{ $t("Slopegradient") }}
                                </td>
                                <td>

                                  <SlopeSettingInput variant="underlined"
                                    :suffix-to-display="getSuffix(cutSettingSlopeUnit.slopeGradient)"
                                    :is-editable="property.cutSettings.isLeftRightDifferent"
                                    :slope-value="property.cutSettings.leftMoundSlope" :step="0.01"
                                    v-model.number="property.cutSettings.leftMoundSlope"
                                    :max-value="cutSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                    :min-value="0.01" :decimal-length="2" :un-valid-zero="false"></SlopeSettingInput>


                                </td>
                              </tr>
                              <!-- 小段幅 -->
                              <tr>
                                <td>
                                  {{ $t("Bermwidth") }}
                                </td>
                                <td>
                                  <DistanceSettingInput variant="underlined" hide-details density="compact"
                                    :step="0.001" :min-value="0.001" :max-value="99.999" :decimal-length="3"
                                    :disabled="cutLeftRightCondition" v-model="property.cutSettings.leftShelfWidth" />
                                </td>
                              </tr>
                              <!-- 小段勾配 -->
                              <tr>
                                <td>
                                  {{ $t("Bermgradient") }}
                                </td>
                                <td>

                                  <SlopeSettingInput variant="underlined"
                                    :suffix-to-display="getSuffix(cutSettingSlopeUnit.bermGradient)"
                                    :is-editable="!cutLeftRightCondition"
                                    :slope-value="property.cutSettings.leftShelfSlope" :step="0.01"
                                    v-model.number="property.cutSettings.leftShelfSlope"
                                    :max-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                    :min-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                    :decimal-length="2" :un-valid-zero="cutSettingSlopeUnit.bermGradient === 'percent'">
                                  </SlopeSettingInput>

                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                        </v-col>
                        <!-- 右切土設定 -->
                        <v-col class="pa-0">
                          {{ $t("Rightcutsetting") }}
                          <v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)">
                            <tbody>
                              <!-- 法面高さ -->
                              <tr>
                                <td style="width: 45%">
                                  {{ $t("Slopeheight") }}
                                </td>
                                <td>
                                  <DistanceSettingInput variant="underlined" hide-details density="compact"
                                    :step="0.001" :min-value="0.001" :max-value="99.999" :decimal-length="3"
                                    :disabled="cutLeftRightCondition" v-model="property.cutSettings.rightSlopeHeight" />
                                </td>
                              </tr>
                              <!-- 法面勾配 -->
                              <tr>
                                <td>
                                  {{ $t("Slopegradient") }}
                                </td>
                                <td>

                                  <SlopeSettingInput variant="underlined"
                                    :suffix-to-display="getSuffix(cutSettingSlopeUnit.slopeGradient)"
                                    :is-editable="property.cutSettings.isLeftRightDifferent"
                                    :slope-value="property.cutSettings.rightMoundSlope" :step="0.01"
                                    v-model.number="property.cutSettings.rightMoundSlope"
                                    :max-value="cutSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                    :min-value="0.01" :decimal-length="2" :un-valid-zero="false"></SlopeSettingInput>

                                </td>
                              </tr>
                              <!-- 小段幅 -->
                              <tr>
                                <td>
                                  {{ $t("Bermwidth") }}
                                </td>
                                <td>
                                  <DistanceSettingInput variant="underlined" hide-details density="compact"
                                    :step="0.001" :min-value="0.001" :max-value="99.999" :decimal-length="3"
                                    :disabled="cutLeftRightCondition" v-model="property.cutSettings.rightShelfWidth" />
                                </td>
                              </tr>
                              <!-- 小段勾配 -->
                              <tr>
                                <td>
                                  {{ $t("Bermgradient") }}
                                </td>
                                <td>

                                  <SlopeSettingInput variant="underlined"
                                    :suffix-to-display="getSuffix(cutSettingSlopeUnit.bermGradient)"
                                    :is-editable="!cutLeftRightCondition"
                                    :slope-value="property.cutSettings.rightShelfSlope" :step="0.01"
                                    v-model.number="property.cutSettings.rightShelfSlope"
                                    :max-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                    :min-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                    :decimal-length="2" :un-valid-zero="cutSettingSlopeUnit.bermGradient === 'percent'">
                                  </SlopeSettingInput>

                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <!-- 盛土設定 -->
            <v-row class="ma-0">
              <v-col class="py-0">
                {{ $t("Fillsetting") }}
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col>
                <v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)">
                  <tbody>
                    <!-- 法面高さ -->
                    <tr>
                      <td style="width: 50%">
                        {{ $t("Slopeheight") }}
                      </td>
                      <td>
                        <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                          :min-value="0.001" :max-value="99.999" :decimal-length="3" :disabled="embSlopeCondition"
                          @blur="updateRoadSettings()" v-model="property.fillSettings.roadHeight" />
                      </td>
                    </tr>
                    <!-- 法面勾配 -->
                    <tr>
                      <td>
                        {{ $t("Slopegradient") }}
                      </td>
                      <td>

                        <SlopeSettingInput variant="underlined"
                          :suffix-to-display="getSuffix(fillSettingSlopeUnit.slopeGradient)"
                          :is-editable="!property.fillSettings.isLeftRightDifferent"
                          :slope-value="property.fillSettings.moundSlope" :step="0.01" @blur="updateRoadSettings()"
                          v-model.number="property.fillSettings.moundSlope"
                          :max-value="fillSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                          :min-value="0.01" :decimal-length="2" :un-valid-zero="false"></SlopeSettingInput>


                      </td>
                    </tr>
                    <!-- 小段幅 -->
                    <tr>
                      <td>
                        {{ $t("Bermwidth") }}
                      </td>
                      <td>
                        <DistanceSettingInput variant="underlined" hide-details density="compact" :step="0.001"
                          :min-value="0.001" :max-value="99.999" :decimal-length="3" :disabled="embSlopeCondition"
                          @blur="updateRoadSettings()" v-model="property.fillSettings.shelfWidth" />
                      </td>
                    </tr>
                    <!-- 小段勾配 -->
                    <tr>
                      <td>
                        {{ $t("Bermgradient") }}
                      </td>
                      <td>

                        <SlopeSettingInput variant="underlined"
                          :suffix-to-display="getSuffix(fillSettingSlopeUnit.bermGradient)"
                          :is-editable="!embSlopeCondition" :slope-value="property.fillSettings.shelfSlope" :step="0.01"
                          @blur="updateRoadSettings()" v-model.number="property.fillSettings.shelfSlope"
                          :max-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                          :min-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01" :decimal-length="2"
                          :un-valid-zero="fillSettingSlopeUnit.bermGradient === 'percent'"></SlopeSettingInput>


                      </td>
                    </tr>
                    <!-- 左右設定 -->
                    <tr>
                      <td>
                        {{ $t("LeftRightSettings") }}
                      </td>
                      <td>
                        <v-checkbox color="primary" hide-details density="compact" class="ma-0"
                          @change="updateRoadSettings()"
                          v-model="property.fillSettings.isLeftRightDifferent"></v-checkbox>
                      </td>
                    </tr>
                    <!-- 小段あり -->
                    <tr>
                      <td>
                        {{ $t("Thereisberm") }}
                      </td>
                      <td>
                        <v-checkbox color="primary" hide-details density="compact" class="ma-0"
                          v-model="property.fillSettings.generateShelf"></v-checkbox>
                      </td>
                    </tr>
                    <!-- 法面色 -->
                    <tr>
                      <td>
                        {{ $t("SLOPE_COLOR") }}
                      </td>
                      <td>
                        <v-menu>
                          <template v-slot:activator="{ props }">
                            <v-avatar :color="property.fillSettings.color" size="20px" v-bind="props">
                            </v-avatar>
                          </template>
                          <v-color-picker class="ma-0" hide-canvas hide-inputs hide-sliders show-swatches mode="hexa"
                            v-model="property.fillSettings.color"></v-color-picker>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
                <!-- 左右設定 -->
                <v-expansion-panels>
                  <v-expansion-panel style="background-color: rgba(41, 41, 47, 0)">
                    <v-expansion-panel-title class="px-4 py-0">
                      {{ $t("Leftrightsetting") }}
                    </v-expansion-panel-title>
                    <v-expansion-panel-text class="pt-2">
                      <v-row class="ma-0">
                        <!-- 左盛土設定 -->
                        <v-col class="pa-0">
                          {{ $t("Leftfillsetting") }}
                          <v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)" class="pa-0">
                            <tbody>
                              <!-- 法面高さ -->
                              <tr>
                                <td style="width: 45%">
                                  {{ $t("Slopeheight") }}
                                </td>
                                <td>
                                  <DistanceSettingInput variant="underlined" hide-details density="compact"
                                    :step="0.001" :min-value="0.001" :max-value="99.999" :decimal-length="3"
                                    :disabled="embLeftRightCondition" v-model="property.fillSettings.leftSlopeHeight" />
                                </td>
                              </tr>
                              <!-- 法面勾配 -->
                              <tr>
                                <td>
                                  {{ $t("Slopegradient") }}
                                </td>
                                <td>

                                  <SlopeSettingInput variant="underlined"
                                    :suffix-to-display="getSuffix(fillSettingSlopeUnit.slopeGradient)"
                                    :is-editable="property.fillSettings.isLeftRightDifferent"
                                    :slope-value="property.fillSettings.leftMoundSlope" :step="0.01"
                                    v-model.number="property.fillSettings.leftMoundSlope"
                                    :max-value="fillSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                    :min-value="0.01" :decimal-length="2" :un-valid-zero="false"></SlopeSettingInput>

                                </td>
                              </tr>
                              <!-- 小段幅 -->
                              <tr>
                                <td>
                                  {{ $t("Bermwidth") }}
                                </td>
                                <td>
                                  <DistanceSettingInput variant="underlined" hide-details density="compact"
                                    :step="0.001" :min-value="0.001" :max-value="99.999" :decimal-length="3"
                                    :disabled="embLeftRightCondition" v-model="property.fillSettings.leftShelfWidth" />
                                </td>
                              </tr>
                              <!-- 小段勾配 -->
                              <tr>
                                <td>
                                  {{ $t("Bermgradient") }}
                                </td>
                                <td>

                                  <SlopeSettingInput variant="underlined"
                                    :suffix-to-display="getSuffix(fillSettingSlopeUnit.bermGradient)"
                                    :is-editable="!embLeftRightCondition"
                                    :slope-value="property.fillSettings.leftShelfSlope" :step="0.01"
                                    v-model.number="property.fillSettings.leftShelfSlope"
                                    :max-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                    :min-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                    :decimal-length="2"
                                    :un-valid-zero="fillSettingSlopeUnit.bermGradient === 'percent'">
                                  </SlopeSettingInput>

                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                        </v-col>
                        <!-- 右盛土設定 -->
                        <v-col class="pa-0">
                          {{ $t("Rightfillsetting") }}
                          <v-table hover density="compact" style="background-color: rgba(41, 41, 47, 0)">
                            <tbody>
                              <!-- 法面高さ -->
                              <tr>
                                <td style="width: 45%">
                                  {{ $t("Slopeheight") }}
                                </td>
                                <td>
                                  <DistanceSettingInput variant="underlined" hide-details density="compact"
                                    :step="0.001" :min-value="0.001" :max-value="99.999" :decimal-length="3"
                                    :disabled="embLeftRightCondition"
                                    v-model="property.fillSettings.rightSlopeHeight" />
                                </td>
                              </tr>
                              <!-- 法面勾配 -->
                              <tr>
                                <td>
                                  {{ $t("Slopegradient") }}
                                </td>
                                <td>

                                  <SlopeSettingInput variant="underlined"
                                    :suffix-to-display="getSuffix(fillSettingSlopeUnit.slopeGradient)"
                                    :is-editable="property.fillSettings.isLeftRightDifferent"
                                    :slope-value="property.fillSettings.rightMoundSlope" :step="0.01"
                                    v-model.number="property.fillSettings.rightMoundSlope"
                                    :max-value="fillSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                    :min-value="0.01" :decimal-length="2" :un-valid-zero="false"></SlopeSettingInput>

                                </td>
                              </tr>
                              <!-- 小段幅 -->
                              <tr>
                                <td>
                                  {{ $t("Bermwidth") }}
                                </td>
                                <td>
                                  <DistanceSettingInput variant="underlined" hide-details density="compact"
                                    :step="0.001" :min-value="0.001" :max-value="99.999" :decimal-length="3"
                                    :disabled="embLeftRightCondition" v-model="property.fillSettings.rightShelfWidth" />
                                </td>
                              </tr>
                              <!-- 小段勾配 -->
                              <tr>
                                <td>
                                  {{ $t("Bermgradient") }}
                                </td>
                                <td>

                                  <SlopeSettingInput variant="underlined"
                                    :suffix-to-display="getSuffix(fillSettingSlopeUnit.bermGradient)"
                                    :is-editable="!embLeftRightCondition"
                                    :slope-value="property.fillSettings.rightShelfSlope" :step="0.01"
                                    v-model.number="property.fillSettings.rightShelfSlope"
                                    :max-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                    :min-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                    :decimal-length="2"
                                    :un-valid-zero="fillSettingSlopeUnit.bermGradient === 'percent'">
                                  </SlopeSettingInput>
                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col>
            <v-card-actions class="justify-end">
              <v-btn variant="flat" @click="closeDialog" color="red" :disabled="isRoadAdded">
                {{ $t("CANCEL") }}
              </v-btn>
              <v-btn variant="flat" @click="addRoad()" color="primary"
                :disabled="!isValid || addRoadDisabled || isRoadAdded">
                {{ $t("ADD") }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { longitudinalSlope } from "@/config/numberConfig";
import { RoadObject } from "@/models/objects/RoadObject";
import { notifyError } from "@/utils/notificationUtils";
import rules from "@/utils/validation-rules.js";
import axios from "axios";
import { useStore } from "vuex";
import { UnitTypes } from "../../constant";
import SlopeSettingInput from "./SlopeSettingInput.vue";
import type { ICrossSection } from "@/models/objects/types";
import NumericSettingInput from "./NumericSettingInput.vue";
import DistanceSettingInput from "./DistanceSettingInput.vue";

export default {
	name: "PropertyDialogRoad",
	components: { SlopeSettingInput, NumericSettingInput, DistanceSettingInput },
	props: {
		id: String,
	},
	async beforeMount() {
		this.property = new RoadObject();
		this.property.id = this.id;
	},
	data: () => ({
		isValid: false,
		property: null as RoadObject,
		slopeValue: 0,
		defaultSlopeValue: 0,
		referencePointIndex: 0,
		isRoadAdded: false,
		isSlopeValueEnabled: false,
		longitudinalSlope,
		rules: {
			...rules,
			required: (value) => !!value || "*",
			validName: (v) => !/[~@#$^*()+=[\]{}|\\,?:<>!'"/;&₹€`%]/.test(v),
		},
		store: useStore(),
	}),
	computed: {
		// Disabling condition for cut setting's - shelfSlope, shelfWidth
		cutSlopeCondition() {
			return (
				this.property.cutSettings.isLeftRightDifferent ||
				!this.property.cutSettings.generateShelf
			);
		},
		// Disabling condition for embankment setting's - shelfSlope, shelfWidth
		embSlopeCondition() {
			return (
				this.property.fillSettings.isLeftRightDifferent ||
				!this.property.fillSettings.generateShelf
			);
		},
		// Disabling condition for cut setting's - leftShelfWidth, leftShelfSlope, rightShelfWidth, rightShelfSlope
		cutLeftRightCondition() {
			return !(
				this.property.cutSettings.isLeftRightDifferent &&
				this.property.cutSettings.generateShelf
			);
		},
		// Disabling condition for embankment setting's - leftShelfWidth, leftShelfSlope, rightShelfWidth, rightShelfSlope
		embLeftRightCondition() {
			return !(
				this.property.fillSettings.isLeftRightDifferent &&
				this.property.fillSettings.generateShelf
			);
		},
		roadParameterSlopeUnit() {
			return this.store.state.roadParameterSlopeUnit;
		},
		cutSettingSlopeUnit() {
			return this.store.state.cutSettingSlopeUnit;
		},
		fillSettingSlopeUnit() {
			return this.store.state.fillSettingSlopeUnit;
		},
		addRoadDisabled: function () {
			return (
				this.property.name === null ||
				this.property.name === "" ||
				/^\s*$/.test(this.property.name)
			);
		},
		slopeTypes() {
			return [
				{
					label: this.$t("Crossslope"),
					value: false,
				},
				{
					label: this.$t("Superelevation"),
					value: true,
				},
			];
		},
		controlPointsLength() {
			return this.store.getters.viewer.getRoadPointLength(this.id);
		},
		longitudinalReferencePoints() {
			return [
				{
					label: `0（${this.$t("START_POINT")}）`,
					value: 0,
				},
				{
					label: `${this.controlPointsLength - 1}（${this.$t("END_POINT")}）`,
					value: this.controlPointsLength - 1,
				},
			];
		},
	},
	watch: {
		isSlopeValueEnabled(newValue) {
			if (!newValue) {
				// チェックオフがオフになったら縦断勾配、参照基準点をデフォルト値に戻す
				this.slopeValue = this.defaultSlopeValue;
				this.referencePointIndex = 0;
			}
		},
	},
	methods: {
		resetProperty() {
			this.property.update(this.property.default);
			this.isRoadAdded = false;
		},
		getSuffix(unitType) {
			const unit = UnitTypes.find((type) => type.value === unitType);
			return unit.symbol;
		},
		closeDialog() {
			this.store.getters.viewer.deleteRoad(this.id);
			this.$emit("close", false);
			this.property.update(this.property.default);
		},
		async addRoad() {
			this.isRoadAdded = true;
			// ローディング開始
			await this.store.dispatch("executeWithSpinner", async () => {
				try {
					const {
						associatedTerrain,
						surveyPoints,
						horizontalAlignment,
						verticalAlignment,
						ipPointIds,
					} = this.store.getters.viewer.getRoadJSON(this.id);

					this.property.associatedTerrain = associatedTerrain;
					this.property.surveyPoints = surveyPoints;
					this.property.horizontalAlignment = horizontalAlignment;
					this.property.verticalAlignment = verticalAlignment;
					this.property.ipPointIds = ipPointIds;

					this.store.getters.viewer.deleteRoad(this.id);

					await this.property.loadInViewer();

					// Soil volume calculation
					const volume =
						await this.store.getters.viewer.volumeCalculationForRoad(this.id);
					const { cutVolume = 0, fillVolume = 0 } = volume ?? {};
					this.property.cutVolume = cutVolume.toFixed(3);
					this.property.fillVolume = fillVolume.toFixed(3);

					const objConnectionJSON =
						this.store.getters.viewer.getConnectionsInSiteJSON();
					this.property.length = this.store.getters.viewer.getLengthOfRoad(
						this.id,
					);
					this.property.heightRange =
						this.store.getters.viewer.getRoadHeightInfo(this.id);
					this.property.slopeRange = this.store.getters.viewer.getRoadSlopeInfo(
						this.id,
					);

					const propsJSON = await this.property.toJSON();

					const res = await axios.post(
						`${import.meta.env.VITE_API_BASE}/obj/${this.$route.query.siteId}`,
						{
							siteId: this.$route.query.siteId,
							objJSON: {},
							objProps: propsJSON,
							objConnectionJSON: objConnectionJSON,
						},
						{
							auth: this.store.state.authObject,
						},
					);
					// オブジェクトリストの更新
					await this.store.dispatch("object/get_obj", this.id); // adds the object

					// 追加した仮設道路を可視化する
					const addedObj = this.store.state.object.objects.find(
						(entity) => entity.id === this.id,
					);
					if (addedObj) {
						addedObj.isLoaded = true;
						addedObj.isVisible.ipLine = true;
						addedObj.isVisible.centerLine = false;
						addedObj.isVisible.surface = true;
						addedObj.isVisible.cutEmbankment = true;
						addedObj.isVisible.fillEmbankment = true;
						addedObj.isVisible.crossSection = false;

						// Save cross-section settings for the road
						try {
							const savedSettings: ICrossSection = await this.store.dispatch(
								"lineWorksCrossSection/saveCrossSectionOnCreate",
								{
									object: addedObj,
									siteId: this.$route.query.siteId,
									crossSectionParams: this.property.crossSectionSetting,
								},
							);
							if (savedSettings) {
								addedObj.crossSectionSetting = {
									id: savedSettings.cross_section_id,
									leftWidth:
										savedSettings.left_side_width ??
										this.property.crossSectionSetting.leftWidth,
									rightWidth:
										savedSettings.right_side_width ??
										this.property.crossSectionSetting.rightWidth,
									interpolationPitch:
										savedSettings.station_interval ??
										this.property.crossSectionSetting.interpolationPitch,
									samplingSize:
										savedSettings.sampling_size ??
										this.property.crossSectionSetting.samplingSize,
								};
							}
						} catch (error: unknown) {
							console.error("Failed to save cross-section settings:", error);
						}
					}
				} catch (e: unknown) {
					console.error(e);
					this.store.getters.viewer.deleteRoad(this.id);
					notifyError(this, this.$t("ROAD_SAVE_FAILURE"));
				}
			});
			this.$emit("close", false);
		},
		isNum(val) {
			return typeof val == "number";
		},
		updateRoadSettings(isAI = false, leftWidth = 2.5, rightWidth = 2.5) {
			if (this.id === null) return;

			if (isAI) {
				this.property.pathSettings.leftWidth = leftWidth;
				this.property.pathSettings.rightWidth = rightWidth;
			}

			this.property.pathSettings.rightSlope = this.property.pathSettings
				.isSuperElevation
				? -1 * this.property.pathSettings.leftSlope
				: this.property.pathSettings.leftSlope;

			if (!this.property.fillSettings.isLeftRightDifferent) {
				this.property.fillSettings.leftMoundSlope =
					this.property.fillSettings.moundSlope;
				this.property.fillSettings.rightMoundSlope =
					this.property.fillSettings.moundSlope;
				this.property.fillSettings.leftShelfSlope =
					this.property.fillSettings.shelfSlope;
				this.property.fillSettings.rightShelfSlope =
					this.property.fillSettings.shelfSlope;
				this.property.fillSettings.leftShelfWidth =
					this.property.fillSettings.shelfWidth;
				this.property.fillSettings.rightShelfWidth =
					this.property.fillSettings.shelfWidth;
				this.property.fillSettings.leftSlopeHeight =
					this.property.fillSettings.roadHeight;
				this.property.fillSettings.rightSlopeHeight =
					this.property.fillSettings.roadHeight;
			}

			if (!this.property.cutSettings.isLeftRightDifferent) {
				this.property.cutSettings.leftMoundSlope =
					this.property.cutSettings.moundSlope;
				this.property.cutSettings.rightMoundSlope =
					this.property.cutSettings.moundSlope;
				this.property.cutSettings.leftShelfSlope =
					this.property.cutSettings.shelfSlope;
				this.property.cutSettings.rightShelfSlope =
					this.property.cutSettings.shelfSlope;
				this.property.cutSettings.leftShelfWidth =
					this.property.cutSettings.shelfWidth;
				this.property.cutSettings.rightShelfWidth =
					this.property.cutSettings.shelfWidth;
				this.property.cutSettings.leftSlopeHeight =
					this.property.cutSettings.roadHeight;
				this.property.cutSettings.rightSlopeHeight =
					this.property.cutSettings.roadHeight;
			}
		},
	},
};
</script>